module.exports = __webpack_public_path__ + "img/img_2.30ea9dcb.png";